import { topBarText } from "@/mocks/site-data";

export default function TopBar() {
  return (
    <div className="hidden bg-background-100 text-foreground-50 md:block">
      <div className="mx-auto flex h-9 max-w-8xl items-center justify-center px-4 md:px-6">
        <p className="truncate text-[11px] md:text-xs font-medium uppercase tracking-[0.18em] text-accent-300">
          {topBarText}
        </p>
      </div>
    </div>
  );
}